import React from "react";

const CustomCardImportantServices =({title ,image})=>{
    return (
<div className="items-center pb-5 text-white bg-black  duration-300 cursor-pointer transform">
{/* <div className="items-center pb-5 text-white bg-black hover:scale-x-[1.03] duration-300 cursor-pointer transform"> */}
    <img
    src={image}
    alt="image"
    className="w-full p-5"
    />
    <p className="text-center">
        {title}
    </p>
</div>
    )
}
export default CustomCardImportantServices;